import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileDescriptorComponent } from './components/file-descriptor/file-descriptor.component';
//TODO: BORRARimport { FileDecriptorInputComponent } from './components/file-descriptor/file-decriptor-input/file-decriptor-input.component';
import { FileContainerComponent } from './components/file-container/file-container.component';
import { FormsModule } from '@angular/forms';
import { FileDescriptorPreviewDirective } from './directives/file-descriptor-preview.component';
import { FileDescriptorPreviewComponent } from './components/file-descriptor-preview/file-descriptor-preview.component';

@NgModule({
  declarations: [
    FileDescriptorComponent,
    //TODO: BORRAR FileDecriptorInputComponent,
    FileContainerComponent,
    FileDescriptorPreviewDirective,
    FileDescriptorPreviewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    FileDescriptorPreviewDirective,
    FileDescriptorComponent,
    //TODO: BORRARFileDecriptorInputComponent,
    FileContainerComponent,
    FileDescriptorPreviewComponent
  ]
})
export class FileDescriptorModule { }
